import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

export const LeftArrowIcon = () => {
  return (
    <svg
      aria-hidden={true}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={applyDataTestId(pom.icons.leftArrowIcon)}
    >
      <title>Left Arrow</title>
      <path
        d="M20 12H5M5 12L12 5M5 12L12 19"
        stroke="#1F2A37"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
